import { WSInfoBox, WSInfoBoxProps } from "@wingspanhq/fe-component-library";
import React from "react";

export interface DebugDataProps extends WSInfoBoxProps {
  data: any;
}

export const DebugData: React.FC<DebugDataProps> = ({
  data,
  ...otherProps
}) => {
  const json = (() => {
    try {
      const sortKeys = (value: unknown): unknown => {
        if (Array.isArray(value)) {
          return value.map(sortKeys);
        }
        if (value !== null && typeof value === "object") {
          return Object.keys(value as Record<string, unknown>)
            .sort()
            .reduce<Record<string, unknown>>((acc, key) => {
              acc[key] = sortKeys((value as Record<string, unknown>)[key]);
              return acc;
            }, {});
        }
        return value;
      };
      const result = sortKeys(data);
      return JSON.stringify(result, null, 2);
    } catch {
      return JSON.stringify(data, null, 2);
    }
  })();

  return (
    <WSInfoBox {...otherProps}>
      <pre>{json}</pre>
    </WSInfoBox>
  );
};
